import { Spin } from "antd";
import React, { lazy, Suspense } from "react";

const Layout = lazy(() => import("../featuresNew/Layout"));

// Fallback component while loading
const Loading = () => (
  <div
    style={{
      display: "flex",
      height: "100vh",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Spin tip="Loading.." size="large">
      <div style={{ padding: 48 }} />
    </Spin>
  </div>
);

export const newRoutes = [
  {
    key: "layout",
    path: "/*",
    element: (
      <Suspense fallback={<Loading />}>
        <Layout />
      </Suspense>
    ),
  },
];
